import { cn } from "@/lib/cn";

// Soft animated gradient "blobs" + grid — the trending mesh background used
// behind the hero and auth pages. Purely decorative (aria-hidden).
export default function Aurora({ className }) {
  return (
    <div
      aria-hidden="true"
      className={cn("pointer-events-none absolute inset-0 overflow-hidden", className)}
    >
      {/* faint grid */}
      <div className="absolute inset-0 bg-grid-light bg-[size:38px_38px] [mask-image:radial-gradient(ellipse_at_center,black,transparent_72%)] dark:bg-grid-dark" />

      {/* drifting color blobs */}
      <div className="absolute -left-24 -top-24 h-80 w-80 animate-blob rounded-full bg-brand-400/30 blur-3xl dark:bg-brand-500/20" />
      <div className="absolute right-0 top-10 h-72 w-72 animate-blob rounded-full bg-fuchsia-400/25 blur-3xl [animation-delay:3s] dark:bg-fuchsia-500/15" />
      <div className="absolute bottom-0 left-1/3 h-72 w-72 animate-blob rounded-full bg-sky-400/25 blur-3xl [animation-delay:6s] dark:bg-sky-500/15" />
    </div>
  );
}
